module.exports = __webpack_public_path__ + "static/media/LK_Arrow up.b2aed894.svg";